import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, useLocation  } from "react-router-dom";

// CSS files
import '../styles/index.css'
import '../styles/App.css'
import '../styles/Colors.css'
import '../styles/mobile/App.css'

// Component/source files
const Resume = lazy(() => import('./Resume.jsx'));
const Homepage = lazy(() => import('./Homepage.jsx'));
const Projects = lazy(() => import('./Projects.jsx'));

import Sidebar from '../components/Sidebar.jsx'
import Transitioner from '../components/Transitioner.jsx';
import Swiper from '../components/Swiper.jsx';
import { SidebarProvider } from '../components/SidebarContext.jsx';

function AnimatedRoutes() {
  const location = useLocation();

  
  // Define transitions for specific routes
  const transitionMap = {
    '/': 'fade',
    '/resume': 'slide',
    '/projects': 'slide-right',
    // Add more routes as needed
  };

  const transitionType = transitionMap[location.pathname] || 'fade';

  return (
    <Transitioner
      key = {location.pathname}
      animation={transitionType}
      duration={500}>

      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Homepage />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/projects" element={<Projects />} />
      </Routes>
    
    </Transitioner>
  );
}

const isMobile = window.innerWidth <= 768;
const Wrapper = isMobile ? Swiper : ({ children }) => <div>{children}</div>;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Router>
      <SidebarProvider>
        <Wrapper>
          <Suspense fallback={<div className="spinner">Loading...</div>}>
              <AnimatedRoutes />
              <Sidebar />
          </Suspense>
        </Wrapper>
      </SidebarProvider>
    </Router>
  </StrictMode>,
)
